/**
 * 表单验证工具
 */

/** 验证规则 */
export const validators = {
  /** 手机号验证（11位，1开头） */
  phone: (value: string): boolean => /^1[3-9]\d{9}$/.test(value),
  
  /** 中文姓名验证（2-10个汉字） */
  name: (value: string): boolean => /^[\u4e00-\u9fa5]{2,10}$/.test(value),
  
  /** 学校名称验证（4-50个字符） */
  school: (value: string): boolean => value.length >= 4 && value.length <= 50,
};

/** 错误提示消息 */
export const errorMessages = {
  phone: '请输入正确的11位手机号',
  name: '请输入2-10个汉字的姓名',
  school: '学校名称需要4-50个字符',
  required: '此项为必填项',
};

/** 表单字段验证配置 */
export interface FieldValidation {
  required?: boolean;
  validator?: (value: string) => boolean;
  message?: string;
}

/** 验证单个字段 */
export const validateField = (
  value: string,
  validation: FieldValidation
): string | null => {
  if (validation.required && !value.trim()) {
    return errorMessages.required;
  }
  
  if (validation.validator && value.trim() && !validation.validator(value)) {
    return validation.message || '格式不正确';
  }
  
  return null;
};

/** 表单字段验证规则映射 */
export const formValidationRules: Record<string, FieldValidation> = {
  studentName: {
    required: true,
    validator: validators.name,
    message: errorMessages.name,
  },
  studentSchool: {
    required: true,
    validator: validators.school,
    message: errorMessages.school,
  },
  phone: {
    required: true,
    validator: validators.phone,
    message: errorMessages.phone,
  },
  parentName: {
    required: true,
    validator: validators.name,
    message: errorMessages.name,
  },
  mentorName: {
    required: true,
    validator: validators.name,
    message: errorMessages.name,
  },
  mentorPhone: {
    required: true,
    validator: validators.phone,
    message: errorMessages.phone,
  },
};

/** 验证整个表单 */
export const validateForm = (
  data: Record<string, string>
): Record<string, string | null> => {
  const errors: Record<string, string | null> = {};
  
  for (const [field, value] of Object.entries(data)) {
    const rule = formValidationRules[field];
    if (rule) {
      errors[field] = validateField(value, rule);
    }
  }
  
  return errors;
};

/** 检查是否有验证错误 */
export const hasErrors = (errors: Record<string, string | null>): boolean => {
  return Object.values(errors).some((error) => error !== null);
};
